import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

const AlertDialog = (props, ref) => {
    const
        _children = props.children,
        _dialogDisplay = props.dialogDisplay,
        _setDialogDisplay = props.setDialogDisplay

    const handleClose = () => {
        _setDialogDisplay(false)
    }

    return (
        <Dialog
            open={_dialogDisplay}
            onClose={handleClose}
            fullWidth={true}
        >
            <DialogTitle>Alert</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {_children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AlertDialog
